<script lang="ts">
import GuestLayout from "@/layouts/GuestLayout.vue"

export default { layout: GuestLayout }
</script>

<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3"
import { ref, useTemplateRef } from "vue"
import { z } from "zod"

import DevToolsButton from "@/components/dev/DevToolsButton.vue"
import DevToolsMailpitButton from "@/components/dev/DevToolsMailpitButton.vue"
import DevToolsPopover from "@/components/dev/DevToolsPopover.vue"
import FlashAlerts from "@/components/FlashAlerts.vue"
import { newPasswordPath, sessionPath } from "@/routes"

const loading = ref(false)
const authFormRef = useTemplateRef("authFormRef")

const schema = z.object({
  email_address: z.string().email("Please enter a valid email address"),
  password: z.string().min(1, "Password is required"),
})

function submit() {
  if (!authFormRef.value) return
  loading.value = true
  router.post(sessionPath(), authFormRef.value.state, {
    onFinish: () => {
      loading.value = false
    },
  })
}

function populateLogin(email: string, password: string) {
  const s = authFormRef.value?.state as z.infer<typeof schema> | undefined
  if (s) {
    s.email_address = email
    s.password = password
  }
}
</script>

<template>
  <Head title="Sign In" />
  <UAuthForm
    ref="authFormRef"
    title="Ninjanizr"
    description="Sign in to your account"
    :schema="schema"
    :fields="[
      {
        name: 'email_address',
        label: 'Email',
        type: 'email',
        required: true,
        placeholder: 'you@example.com',
        autocomplete: 'username',
      },
      {
        name: 'password',
        label: 'Password',
        type: 'password',
        required: true,
        autocomplete: 'current-password',
      },
    ]"
    :loading="loading"
    :submit="{ label: 'Sign In' }"
    @submit="submit"
  >
    <template #validation>
      <FlashAlerts />
    </template>

    <template #password-hint>
      <UButton
        :to="newPasswordPath()"
        variant="link"
        size="xs"
        label="Forgot password?"
        class="text-muted"
      />
    </template>

    <template #footer>
      <DevToolsPopover>
        <DevToolsButton
          label="App Dev (super admin)"
          @click="populateLogin('appdev@sevenview.ca', 'Nitro777')"
        />
        <DevToolsButton label="Steve" @click="populateLogin('steve@sevenview.ca', 'Nitro777')" />
        <DevToolsButton label="Clint" @click="populateLogin('clint@example.com', 'password123')" />
        <DevToolsButton label="Dana" @click="populateLogin('dana@example.com', 'password123')" />
        <DevToolsMailpitButton />
      </DevToolsPopover>
    </template>
  </UAuthForm>
</template>
